<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('学生列表') }}</h4>
            <div class="flex flex-v-center">
                <el-input style="border-radius: 20px;" clearable :placeholder="$t('请输入学生名称')" v-model="name">
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
        </div>

        <el-table :header-cell-style="{ background: '#f5f7fa', color: '#333', 'border-radius': '4px' }" class="margin-t"
            :data="tableData" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有班级数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column prop="name" :label="$t('学生名称')" width="140">
            </el-table-column>
            <el-table-column align="center" prop="user_id" :label="$t('User ID')" width="120">
            </el-table-column>
            <el-table-column align="center" prop="clazz_name" :label="$t('班级名称')">
                <template slot-scope="scope">
                    <el-tag>{{ scope.row.clazz_name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="created_at" :label="$t('加入时间')">
            </el-table-column>
            <el-table-column align="center" prop="sources_count" :label="$t('近3天练习次数')">
            </el-table-column>
            <el-table-column align="center" prop="works_count" :label="$t('提交作业次数')">
            </el-table-column>

            <el-table-column align="center" prop="address" :label="$t('操作')">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="get_student(scope.row)">{{ $t('更多') }}<i
                            class="el-icon-arrow-right"></i></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog fullscreen v-if="student" center :title="student.name" :visible.sync="dialogVisible" width="50%">
            <h3 slot="title" class="padding">{{ student.name }}</h3>
            <el-card style="width:600px;">
                <h3 slot="header" class="flex flex-between"><span>{{ $t('目标分数') }}</span>
                    <el-tag>{{ $t('剩余') }} : {{ days }} {{ $t('天') }}</el-tag>
                </h3>
                <el-table
                    :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                    class="margin-t" :data="exam_data" style="width: 100%">
                    <el-empty slot="empty" :image-size="100" :description="$t('还没有目标分数')"
                        style="margin-top: 100px;"></el-empty>
                    <el-table-column align="center" prop="t" :label="$t('总分')">

                    </el-table-column>
                    <el-table-column align="center" prop="s" :label="$t('口语')">
                    </el-table-column>
                    <el-table-column align="center" prop="w" :label="$t('写作')">
                    </el-table-column>
                    <el-table-column align="center" prop="r" :label="$t('阅读')">
                    </el-table-column>
                    <el-table-column align="center" prop="l" :label="$t('听力')">
                    </el-table-column>
                </el-table>
            </el-card>


            <el-card class="margin-t">
                <h3 slot="header" class="flex flex-between"><span>{{ $t('历史成绩') }}</span>
                </h3>
                <el-table
                    :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                    class="margin-t" :data="score_list" style="width: 100%">
                    <el-empty slot="empty" :image-size="100" :description="$t('还没有目标分数')"
                        style="margin-top: 100px;"></el-empty>
                    <el-table-column align="center" prop="day" :label="$t('时间')">
                    </el-table-column>
                    <el-table-column align="center" prop="t" :label="$t('总分')">
                    </el-table-column>
                    <el-table-column align="center" prop="s" :label="$t('口语')">
                    </el-table-column>
                    <el-table-column align="center" prop="w" :label="$t('写作')">
                    </el-table-column>
                    <el-table-column align="center" prop="r" :label="$t('阅读')">
                    </el-table-column>
                    <el-table-column align="center" prop="l" :label="$t('听力')">
                    </el-table-column>
                </el-table>
            </el-card>

            <el-card class="margin-t">
                <div slot="header" class="flex flex-between flex-v-center">
                    <h3>{{ $t('历史练习记录') }} ({{ $t('近30天') }})</h3>
                    <!-- <el-link @click="to('/main/record')">{{ $t('更多记录') }}<i class="el-icon-arrow-right"></i></el-link> -->
                </div>
                <el-row :gutter="15">
                    <el-col :span="12">
                        <template v-for="(item, index0) in records">
                            <el-card v-if="index0 % 2 == 0" class="margin-b" :key="index0">
                                <div slot="header" class="flex flex-between">
                                    <span class="mt bold">{{ item.day }}</span>
                                    <span class="mt margin-r">{{ $t('练习题数') }}: {{ item.count }} {{ $t('题') }}</span>
                                </div>

                                <el-menu default-active="0" router>
                                    <el-menu-item @click="showDetail(item, type)" :id="type.tag" v-for="(type, index1) in item.items" :key="index1"
                                        class="border br margin" style="height:60px">
                                        <div class="flex flex-between flex-v-center" style="height:100%">
                                            <div class="flex flex-v-center">
                                                <el-image :src="$host + type.logo"
                                                    style="width:40px;height: 40px;"></el-image>
                                                <span class="margin-x st1 bold">{{ type.tag }}</span>
                                            </div>
                                            <span class="mt">{{ $t('已练') }}: {{ type.count }} {{ $t('题') }}<i
                                                    class="el-icon-arrow-right color-primary"></i></span>
                                        </div>

                                    </el-menu-item>
                                </el-menu>
                            </el-card>
                        </template>
                    </el-col>

                    <el-col :span="12">
                        <template v-for="(item, index0) in records">
                            <el-card v-if="index0 % 2 == 1" class="margin-b" :key="index0">
                                <div slot="header" class="flex flex-between">
                                    <span class="mt bold">{{ item.day }}</span>
                                    <span class="mt margin-r">{{ $t('练习题数') }}:{{ item.count }} {{ $t('题') }}</span>
                                </div>

                                <el-menu default-active="0" router>
                                    <el-menu-item @click="showDetail(item, type)" :id="type.tag"
                                        v-for="(type, index1) in item.items" :key="index1" class="border br margin"
                                        style="height:60px">
                                        <div class="flex flex-between flex-v-center" style="height:100%">
                                            <div class="flex flex-v-center">
                                                <el-image :src="$host + type.logo"
                                                    style="width:40px;height: 40px;"></el-image>
                                                <span class="margin-x st1 bold">{{ type.tag }}</span>
                                            </div>
                                            <span class="mt">{{ $t('已练') }}: {{ type.count }} {{ $t('题') }}<i
                                                    class="el-icon-arrow-right color-primary"></i></span>
                                        </div>

                                    </el-menu-item>
                                </el-menu>
                            </el-card>
                        </template>
                    </el-col>
                </el-row>
            </el-card>
        </el-dialog>

        <el-dialog append-to-body :title="$t('练习详情')" center :visible.sync="dialogVisible1" width="50%">
            <el-card class="margin-t" shadow="never">
                <div slot="header" class="flex flex-between pointer flex-v-center pointer">
                    <div class="flex flex-v-center flex1">
                        <el-image style="width:80px;height:80px;" :src="$host + type.logo"></el-image>
                        <div class="margin-x flex1">
                            <h3>{{ type.title }}</h3>

                            <div class="margin-t st1">
                                {{ $t('日期') }}： {{ day }}
                            </div>
                        </div>
                    </div>


                    <div class="flex flex-v-center">
                        <div class="center">
                            <div class="st">{{ $t('练习题数') }}</div>
                            <h1 class="lt margin-ts">{{ list.length }}</h1>
                        </div>
                        <div class="margin-x" style="height: 50px;width:1px;background-color: #eee;"></div>
                        <div class="center">
                            <div class="st">{{ $t('练习次数') }}</div>
                            <h1 class="lt margin-ts">{{ count }}</h1>
                        </div>
                    </div>

                </div>
                <div class="document">
                    <el-menu default-active="0" router>
                        <el-menu-item :id="source.no" v-for="(source, index1) in list" :key="index1"
                             class="border br margin"
                            style="height:60px">
                            <div class="flex flex-between flex-v-center" style="height:100%">
                                <div class="flex flex-v-center">
                                    <span class="margin-x st1 bold">#{{ source.no }} {{ source.title }}</span>
                                </div>
                                <span class="mt">{{ $t('练习') }} {{ source.count }}{{ $t('次') }}</span>
                            </div>
                        </el-menu-item>
                    </el-menu>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            name: '',
            tableData: [],
            dialogVisible: false,
            dialogVisible1: false,
            student: null,
            exam_data: [],
            days: '-',
            score_list: [],
            records: [],
            type: {},
            list: [],
            count: 0,
            day:'',
        }
    },
    created() {
        this.getList();
    },
    methods: {
        showDetail(item, type) {
            this.day = item.day
            this.type = this.$store.getters.getType(type.tag) || {}
            this.$http.post("/api/source/record/detail", { day: item.day, tag: type.tag, user_id: this.student.id }).then((list) => {
                this.list = list;
                let count = 0;
                list.forEach(item => {
                    count += item.count;
                });
                this.count = count;
                this.dialogVisible1 = true
            })
        },
        to(url) {
            this.$router.push(url);
        },
        getList() {
            this.$http.post('/api/student/list', { name: this.name }).then(data => {
                this.tableData = data;
            });
        },
        get_student(row) {
            this.$http.post('/api/student/info', { user_id: row.id }).then(res => {
                this.student = row
                const exam_data = res.exam_data
                if (exam_data) {
                    this.exam_data = [
                        { 's': exam_data[0], 'w': exam_data[1], 'r': exam_data[2], 'l': exam_data[3], 't': exam_data[4] }
                    ]
                }
                this.days = res.days
                this.score_list = res.score_list
                this.records = res.records
                this.dialogVisible = true
            });

        }
    }
};
</script>
